const baseurl =`https://www.demo-new.toon-flix.com/`
export const base_url_toonflix = 'https://backendos.toon-flix.com'
// export const base_url_toonflix = 'http://192.168.1.13:8810'

export {baseurl}

const HomeApi =`${baseurl}api/content/little`
export {HomeApi}
const CommentPostApi =`${baseurl}api/little`
export {CommentPostApi}
 const CommentGETApi =`${baseurl}little/comments`
 export {CommentGETApi}
 